module.exports = ".ProductList_list{margin-top:30px}\n"